<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="party">
					<div class="title-00">
						<h1 class="fl">{{titleName}}</h1>
						<div class="clear"></div>
					</div>
					<div class="erji-content">
						<div class="party-list">
							<list :listId = "this.childId" :page="this.page"></list>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'party',
		data(){
			return{
				childId:'',
				titleName:'',
				page:15
			}
		},
		methods:{
			//请求分类信息
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
		},
		created() {
			this.childId = this.$route.query.category_id;
			this.res_menusClass(this.childId);
			
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>